module.exports = __webpack_public_path__ + "img/simone-ruchesi.8d1022a6.jpg";